<script setup lang="ts">
// Read-only text in the builder's slot colours: every `{{ … }}` slot is split into the tokens BbelField colours,
// and the literal text around the slots stays as written. The token colours live in styles.scss.
import { computed } from "vue";
import { slotTokens } from "./bbel-language";

const props = defineProps<{
  text: string;
  /** The whole text is one expression stored without braces. */
  bare?: boolean;
}>();

interface Segment {
  text: string;
  cls?: string;
}

const segments = computed<Segment[]>(() => {
  // A bare expression is tokenised as one slot, and the braces added for that are not shown.
  const source = props.bare ? `{{${props.text}}}` : props.text;
  const start = props.bare ? 2 : 0;
  const end = props.bare ? source.length - 2 : source.length;
  const tokens = slotTokens(source).filter((token) => token.from >= start && token.to <= end);

  const result: Segment[] = [];
  let at = start;
  for (const token of tokens) {
    if (token.from > at) result.push({ text: source.slice(at, token.from) });
    result.push({ text: source.slice(token.from, token.to), cls: token.cls });
    at = token.to;
  }
  if (at < end) result.push({ text: source.slice(at, end) });
  return result;
});
</script>

<template>
  <span class="slot-text font-monospace"><template v-for="(segment, index) in segments" :key="index"><span v-if="segment.cls" :class="segment.cls">{{ segment.text }}</span><template v-else>{{ segment.text }}</template></template></span>
</template>

<style scoped>
/* Keep the line breaks a multi-line value carries, and break a long URL rather than overflow. */
.slot-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
</style>
